import React from 'react';
import { QueryDataTable } from '~/shared/data-tables/query/QueryDataTable';
import type { GroupVisitToTableProps } from './types';

type TeamSearchOptionType = 'schedule-report-totals-team' | 'schedule-report-totals-team-unassigned';

export function GroupVisitsByTeamTable<T extends TeamSearchOptionType>(props: GroupVisitToTableProps<T>) {
	return (
		<QueryDataTable<T>
			searchType={props.searchType}
			columns={props.columnDefinitions}
			staticFilters={props.staticFilters}
			getRowId={x => x.team.toString()}
			renderRowDetail={row => (
				<props.tableComponent type="inner-with-filters" staticFilters={[{ name: 'team', operator: '==', value: row.team }]} />
			)}
			emptyMessage="No visits found"
		/>
	);
}
